import { Component, EventEmitter, computed, inject } from '@angular/core';
import { ColorSelectionOption } from '@configuration/wizard/models/wizard-model.interface';
import { DyeColorModel } from '@article/model/dye-color.model';
import { SelectionModelService } from '@project/components/article/service/selection-model.service';
import { CompositeArticleInfoUtils } from '@article/util/composite-article-info-utils';

@Component({
  standalone: false,
  selector: 'app-dye-connection',
  templateUrl: './dye-connection.component.html',
  styleUrls: ['./dye-connection.component.scss']
})
export class DyeConnectionComponent {
  private readonly selectionModelService: SelectionModelService = inject(SelectionModelService);
  private readonly compositeArticleInfoUtils: CompositeArticleInfoUtils = inject(CompositeArticleInfoUtils);

  public finish: EventEmitter<ColorSelectionOption | undefined> = new EventEmitter();

  private readonly baseDyeColors: ColorSelectionOption[] = [
    { label: 'color.red', id: 'red', value: '#FF2A1B', color: 'red' },
    { label: 'color.blue', id: 'blue', value: '#007CB0', color: 'blue' },
    { label: 'color.green', id: 'green', value: '#00B51A', color: 'green' },
    { label: 'color.yellow', id: 'yellow', value: '#FFFF00', color: 'yellow' },
    { label: 'color.brown', id: 'brown', value: '#7F4031', color: 'brown' },
    { label: 'color.black', id: 'black', value: '#0e0e10', color: 'black' }, //RAL 9005
    { label: 'color.pink', id: 'pink', value: '#bc4077', color: 'pink' }, //RAL 4010
    { label: 'color.orange', id: 'orange', value: '#da6e00', color: 'orange' }, //RAL 2000
  ];

  public readonly connectionDyeColors = computed<ColorSelectionOption[]>(() => {
    const connections = this.selectionModelService.getConnections();
    let series: string = "";
    if (connections.length > 0) {
      const compositeArticle = this.compositeArticleInfoUtils.getCompositeArticleFromContainer(connections[0].articleContainer);
      const simpleArticle = connections[0].articleContainer.article;
      series = compositeArticle ? compositeArticle.series : simpleArticle.series;
    }
    return [
      ...this.baseDyeColors,
      ...DyeColorModel.getAdditionalDyeColorsByArticleSeries(series),
    ];
  });

  public readonly connectionNoDyeColor: ColorSelectionOption = { label: 'color.no_color', id: 'no_color', value: 'transparent', color: 'no_color' };

  public selectedColor: ColorSelectionOption | undefined = undefined;

  public onSelectedColorChanged(color: ColorSelectionOption): void {
    this.selectedColor = color;
  }

  public cancel(): void {
    this.finish.emit();
  }

  public apply(): void {
    if (this.selectedColor) {
      this.finish.emit(this.selectedColor);
    } else {
      this.cancel();
    }
  }
}
